import * as turf from "@turf/turf";
import MapInfoWindow from "./MapInfoWindow";
import * as geocoder from "@mapbox/mapbox-sdk/services/geocoding";
import DataHandler from "../data/DataHandler";
import {
  Feature,
  GenericJavaScriptObject,
} from "../../interfaces/map.interfaces";
import { Point } from "mapbox-gl";
export default class MapPaintHandler {
  #token =
    "pk.eyJ1IjoicG1lc2NoZW5tb3NlciIsImEiOiJja3JxNmtrZDkwNG95MnZwcWl2N2trN3VoIn0.SIZHloUAU63Grrn6qbz7BA";
  #map: any;
  #datahandler;
  #activeBrushes: GenericJavaScriptObject<any> = {};

  #src: any;
  #polySrc: any;
  #geojson: { type: string; features: Feature[] }; //for lines
  #polyGeojson: { type: string; features: Feature[] };
  #drawnPolys: GenericJavaScriptObject<any> = {};
  #infoWindows: GenericJavaScriptObject<any> = {};
  #geocodingService;

  constructor(datahandler: DataHandler) {
    $("#mappainter").data("obj", this);
    this.#geojson = { type: "FeatureCollection", features: [] };
    this.#polyGeojson = { type: "FeatureCollection", features: [] };
    this.#datahandler = datahandler;
    // @ts-ignore
    this.#geocodingService = geocoder({ accessToken: this.#token });
  }

  setMap(map: any) {
    this.#map = map;
    if (!map.getSource("customlyDrawnLines")) {
      map.addSource("customlyDrawnLines", {
        type: "geojson",
        data: this.#geojson,
      });
      this.#src = map.getSource("customlyDrawnLines");
      map.addLayer({
        id: "customlyDrawnLines",
        type: "line",
        source: "customlyDrawnLines",
        paint: { "line-color": "rgba(255, 0, 98, 0.8)", "line-width": 3 },
      });
      map.moveLayer("customlyDrawnLines");
    }
    if (!map.getSource("customlyDrawnPolys")) {
      map.addSource("customlyDrawnPolys", {
        type: "geojson",
        data: this.#polyGeojson,
      });
      this.#polySrc = map.getSource("customlyDrawnPolys");
      map.addLayer({
        id: "customlyDrawnPolys",
        type: "fill",
        source: "customlyDrawnPolys",
        paint: { "fill-color": "rgba(0, 0, 0, 0.1)" },
      });
      map.moveLayer("customlyDrawnPolys");
    }
  }

  addCoordinates(brushID: string, relativeX: number, relativeY: number) {
    if (!this.#activeBrushes.hasOwnProperty(brushID)) {
      this.#geojson.features.push({
        type: "Feature",
        geometry: { type: "LineString", coordinates: [] },
        properties: { active: true, brushID: brushID },
      });
    }
    this.#activeBrushes[brushID] = [relativeX, relativeY];
    var feature = this.#geojson.features.find(
      (f: any) =>
        f.properties.active &&
        parseInt(f.properties.brushID) === parseInt(brushID)
    );
    if (feature) {
      var screenX = relativeX * $(this.#map._container).width()!;
      var screenY = relativeY * $(this.#map._container).height()!;
      var projected = this.#map.unproject(new Point(screenX, screenY));
      feature.geometry.coordinates.push([projected.lng, projected.lat]);
      this.#src.setData(this.#geojson);
    }
  }

  finishDrawing(brushID: string) {
    const that = this;
    if (this.#activeBrushes.hasOwnProperty(brushID)) {
      var feature = this.#geojson.features.find(
        (f: any) =>
          f.properties.active &&
          parseInt(f.properties.brushID) === parseInt(brushID)
      );
      if (feature) {
        feature.properties.active = false;
        const shapeid = brushID + "-" + +new Date();
        feature.properties.shapeid = shapeid;
        this.#src.setData(this.#geojson);
        const lastCoords =
          feature.geometry.coordinates[feature.geometry.coordinates.length - 1];
        const closedLineCoordinates = feature.geometry.coordinates.concat([
          feature.geometry.coordinates[0],
        ]);
        if (closedLineCoordinates.length < 20) {
          delete this.#activeBrushes[brushID];
          return;
        }
        try {
          const poly: any = turf.lineToPolygon(
            turf.lineString(closedLineCoordinates)
          );
          poly.properties.shapeid = shapeid;
          that.#drawnPolys[shapeid] = poly;
          this.#polyGeojson.features.push(poly);
          this.#polySrc.setData(this.#polyGeojson);

          // find out which hectares are inside the polygon
          const coordinatesToCheck = $("#indicatorghost")
            .data("obj")
            .getAggregatedDataByYear();
          const polygon = poly;
          const polygonCoordinates =
            this.#polyGeojson.features[0].geometry.coordinates[0];

          // Initialize an object to store the sum of indicators per year
          const sumOfIndicatorsByYear: GenericJavaScriptObject<any> = {};
          const sumOfCountsByYear: GenericJavaScriptObject<any> = {};
          var pointsCounter = 0;
          var numberHectaresOutsidePolygon = 0;
          var dataOutsidePolygon = [];

          // Check if coordinatesToCheck is an object and has keys
          if (
            typeof coordinatesToCheck === "object" &&
            Object.keys(coordinatesToCheck).length > 0
          ) {
            // Loop through each set of coordinates
            for (const coordinatesKey in coordinatesToCheck) {
              const coordinates = JSON.parse(coordinatesKey);

              // Ensure that coordinates and coordinates[0] are defined
              if (coordinates && coordinates[0]) {
                const points = turf.points(coordinates[0]);
                const center = turf.center(points);

                if (center && center.geometry && center.geometry.coordinates) {
                  // Check if the center point is inside the polygon
                  if (turf.booleanPointInPolygon(center, polygon)) {
                    // If the center point is inside, update the sum for the corresponding year
                    const data = coordinatesToCheck[coordinatesKey];
                    pointsCounter++;

                    if (data && data.length) {
                      data.forEach((item: any) => {
                        if (!sumOfIndicatorsByYear[item.year]) {
                          sumOfIndicatorsByYear[item.year] = 0;
                          sumOfCountsByYear[item.year] = 0;
                        }
                        sumOfIndicatorsByYear[item.year] += item.indicator;
                        sumOfCountsByYear[item.year]++;
                      });
                    }
                  } else {
                    numberHectaresOutsidePolygon++;
                    const data = coordinatesToCheck[coordinatesKey];

                    dataOutsidePolygon.push(data);
                  }
                }
              }
            }
          }

          // Calculate the average of indicators for each year
          const averageIndicatorsByYear: GenericJavaScriptObject<any> = {};
          for (const year in sumOfIndicatorsByYear) {
            averageIndicatorsByYear[year] =
              sumOfIndicatorsByYear[year] / sumOfCountsByYear[year];
          }

          // put sumOfIndicatorsByYear, averageIndicatorsByYear and pointsCounter into the the aggregatedData object
          const aggregatedData = {
            sumOfIndicatorsByYear,
            averageIndicatorsByYear,
            pointsCounter,
            dataOutsidePolygon,
            numberHectaresOutsidePolygon,
          };

          this.#geocodingService
            .reverseGeocode({
              query: lastCoords,
              limit: 1,
              types: ["address"],
              language: ["de"],
            })
            .send()
            .then((response: any) => {
              var address = "";
              if (response.body.features.length === 1) {
                address = response.body.features[0].place_name_de;
                address = address
                  .replaceAll(", Schweiz", "")
                  .replaceAll(",", ",<br>");
                that.#infoWindows[shapeid] = new MapInfoWindow(
                  shapeid,
                  that.#map,
                  { lng: lastCoords[0], lat: lastCoords[1] } as any,
                  address,
                  aggregatedData,
                  function (thatShapeID: string) {
                    if (that.#polySrc) {
                      //remove the polygon
                      var polygeojson = that.#polySrc._data;
                      polygeojson.features = polygeojson.features.filter(
                        (feature: any) => {
                          return feature.properties.shapeid !== shapeid;
                        }
                      );
                      that.#polySrc.setData(polygeojson);
                      delete that.#drawnPolys[thatShapeID];
                      delete that.#infoWindows[thatShapeID];

                      //remove the red boundary:
                      that.#geojson.features = that.#geojson.features.filter(
                        (feature) => {
                          return feature.properties.shapeid !== shapeid;
                        }
                      );
                      that.#src.setData(that.#geojson);
                    }
                  }
                );
              }
            });
        } catch (e) {
          console.log(e);
        }
      }
      delete this.#activeBrushes[brushID];
    }
  }

  triggerAtMapMove() {
    for (var brushID in this.#activeBrushes) {
      this.finishDrawing(brushID);
    }
  }
}
